export default {
	state: {
		_show: false,
		_text: "",
		_func: null,
		_loading: false,
	},
	
	mutations: {
		mb_show(store) {
			store._show = true
		},
		mb_hide(store) {
			store._show = false
		},
		mb_setText(store, payload) {
			store._text = payload
		},
		mb_setClick(store, payload) {
			store._func = payload
		},
		mb_showLoading(store) {
			store._loading = true
		},
		mb_hideLoading(store) {
			store._loading = false
		},
	},

	getters: {
		mb_show(store) {
			return store._show
		},
		mb_text(store) {
			return store._text
		},
		mb_func(store) {
			return store._func
		},
		mb_loading(store) {
			return store._loading
		},
	}
}
